/*
 * Epic 4 (Cart) — cupom de desconto no "Resumo da compra".
 * Usa a Cart AJAX API nativa do Shopify (/cart/update.js com o parâmetro
 * "discount"), sem depender de app externo. Ao aplicar com sucesso,
 * recarrega a página pra refletir o total já com desconto.
 */
document.addEventListener('DOMContentLoaded', function () {
  var button = document.getElementById('zkr-cart-coupon-apply');
  var input = document.getElementById('zkr-cart-coupon');
  var message = document.getElementById('zkr-cart-coupon-message');

  if (!button || !input) return;

  button.addEventListener('click', function () {
    var code = input.value.trim();
    if (!code) return;

    button.disabled = true;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var applied = cart.cart_level_discount_applications || [];
        var wasApplied = applied.some(function (discount) {
          return (discount.title || '').toLowerCase() === code.toLowerCase();
        });

        if (message) {
          message.hidden = false;
          message.textContent = wasApplied
            ? 'Cupom aplicado com sucesso.'
            : 'Cupom inválido ou expirado.';
          message.classList.toggle('zkr-cart-summary__field-message--error', !wasApplied);
        }

        if (wasApplied) {
          window.location.reload();
        } else {
          button.disabled = false;
        }
      })
      .catch(function () {
        button.disabled = false;
        if (message) {
          message.hidden = false;
          message.textContent = 'Não foi possível aplicar o cupom agora.';
          message.classList.add('zkr-cart-summary__field-message--error');
        }
      });
  });
});
